<template>
  <qx-card-form title="绑定银行卡/完善资料">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="linkUrl" slot-scope="prop">
        <el-input class="inputBox" v-model="prop.form.linkUrl" readonly />
        <el-button class="marLeft" @click="copy(prop.form.linkUrl)">复制链接</el-button>
        <span class="warning marLeft">可复制该地址发给司机让司机绑定银行卡或完善资料</span>
      </section>
      <section slot="qrcode" slot-scope="prop">
        <QrcodeDialog
          :inline="true"
          :inlineText="prop.form.linkUrl"
        />
        <span class="warning marLeft">可让司机扫描二维码去绑定银行卡或完善资料</span>
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  copy,
} from '@qx/utils';
import QrcodeDialog from 'components/qrcodeDialog';
export default {
  components: {
    QrcodeDialog,
  },
  data () {
    return {
      otherFormData: {
        total: '',
        triggerDayNum: '',
      },
      baseForm: {
        form: [
          {
            label: '链接地址',
            value: 'linkUrl',
            default: window.location.origin + '/h5/login.html?callBackUrl=/h5/completeInfo.html',
            slot: true,
          },
          {
            label: '二维码',
            value: 'qrcode',
            slot: true,
          },
        ],
      },
    };
  },
  methods: {
    copy,
    cacheData () {
      return {};
    },
    sub () {
      return {
        qrCodeUrl: window.location.origin + '/h5/login.html?callBackUrl=/h5/completeInfo.html',
      };
    },
  },
};
</script>

<style scoped lang="scss">
.marLeft{
  margin-left: 16px;
}
</style>
